<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="6"
      offset="3"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row
              dense
              no-gutters
            >
              <v-col
                cols="12"
              >
                <v-row
                  dense
                  align="center"
                >
                  <v-col
                    cols="6"
                    v-if="loginMethod === 'email'"
                  >
                    <v-text-field
                                  label="Email"
                                  name="email"
                                  prepend-icon="mdi-email"
                                  type="text"
                                  v-model="email"
                                  :rules="[rules.required]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-switch
                      v-model="allServices"
                      label="All Services Access"
                      :disabled="!!accessSyncSourceId"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-autocomplete
                      :clearable="true"
                      label="Sync Access From Collaborator (Optional)"
                      v-model="accessSyncSourceId"
                      :items="collaboratorOptions"
                      :disabled="allServices"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-autocomplete
                      :clearable="true"
                      label="Services"
                      :multiple="true"
                      :chips="true"
                      v-model="services"
                      :items="availServices"
                      :disabled="allServices || !!accessSyncSourceId"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      :disabled="processing"
                      @click="submitForm"
                    >Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'New',
  data() {
    return {
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
      },
      loginMethod: 'email',
      email: '',
      username: '',
      key: '',
      valid: false,
      services: null,
      availServices: [],
      allServices: false,
      accessSyncSourceId: null,
      collaboratorOptions: [],
    };
  },
  created() {
    this.$api.get('partner/active-cpanel-services').then((response) => {
      this.$set(this, 'availServices', response.data);
    });
    this.$api.post('partner/collaborator/list', {
      per_page: -1,
      current_page: 1,
      search: {},
    }).then((response) => {
      const options = response.data.data.map((item) => ({
        text: item.email || item.username || `Collaborator #${item.id}`,
        value: item.id,
      }));
      this.$set(this, 'collaboratorOptions', options);
    });
  },
  watch: {
    allServices(val) {
      if (val) {
        this.accessSyncSourceId = null;
      }
    },
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$api.post('partner/collaborator/create', {
          method: this.loginMethod,
          email: this.email,
          username: this.username,
          key: this.key,
          services: this.services,
          all_services: this.allServices ? 1 : 0,
          access_sync_source_id: this.accessSyncSourceId,
        })
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'New collaborator is added.',
            });
            this.$refs.form.reset();
            this.loginMethod = 'email';
          })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
